import { CSSProperties, useMemo } from 'react'
import { Toaster as HotToaster } from 'react-hot-toast'

import './Toaster.css'

const toastOptions = {
    className: 'toaster',
    error: { className: 'toaster toaster-error' },
    success: { className: 'toaster toaster-success' },
}

export const Toaster = ({ offsetTop, zIndex }: { offsetTop?: string; zIndex?: number }) => {
    const containerStyle = useMemo(() => {
        const result: CSSProperties = {}
        if (offsetTop) {
            result.top = offsetTop
        }
        if (zIndex) {
            result.zIndex = zIndex
        }
        return result
    }, [offsetTop, zIndex])

    return <HotToaster position="top-center" toastOptions={toastOptions} containerStyle={containerStyle} />
}
